import {
	MatterFileType,
	MatterRequisitionOverview,
	MatterSource,
} from '../db-models/matter';

export interface fnCallable {
	getOutstandingRequisitions: string;
}

export const fnCallable: fnCallable = {
	getOutstandingRequisitions: 'requisition_getOutstanding',
};

export interface GetOutstandingRequisitionsRequest {
	filterProperty: string;
	filterValue: string;
	businessId: string;
}

export interface OutstandingRequisitionsResponse {
	id: string;
	lawyerId: string;
	clerkId: string;
	name: string;
	fileType: MatterFileType;
	number: string;
	closingDate: string;
	requisitions: MatterRequisitionOverview;
	matterSource: MatterSource;
}
